export const TWITTER = "https://twitter.com/whalemembers";
export const YOUTUBE = "https://www.youtube.com/c/WhaleMembers";
export const MEDIUM = "https://medium.com/whalemembers";
export const TWITCH = "https://www.twitch.tv/whalemembers";
export const TELEGRAM = "https://t.me/WHALEMembers";
export const REDDIT = "https://www.reddit.com/r/WHALEMembers/";
export const DISCORD = "https://discord.gg/whale";
export const CENT = "https://beta.cent.co/WhaleShark/";
